export default __webpack_public_path__ + "static/media/ios-s3.ce99179c.webp";